import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=b6ec9c0c&"
import script from "./AdminProfile.vue?vue&type=script&lang=js&"
export * from "./AdminProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports